import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

// eslint-disable-next-line
import VoiceInputButton from "./VoiceInputButton";
import { useToast } from "../utils/useToast";


const SwapForm = ({
  foodList = [],
  selectedFood,
  onFoodChange,
  onFetchSwap,
  loading,
  limitReached
}) => {

  const { showToast } = useToast();
  const selectRef = useRef(null);
  // eslint-disable-next-line
  const [isListening, setIsListening] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [filteredFoodList, setFilteredFoodList] = useState([]);
  // eslint-disable-next-line
  const [placeholderText, setPlaceholderText] = useState("Search foods...");
  const [shouldForceOpen, setShouldForceOpen] = useState(false);
  // eslint-disable-next-line
  const [tooltip, setTooltip] = useState("");
  const [lastSelectedFood, setLastSelectedFood] = useState(selectedFood);

  const handleFetchSwap = () => {
    const cleaned = selectedFood.trim().toLowerCase();

    if (!cleaned) {
      showToast("Please select a food to swap.", "error");
      return;
    }

    const match = foodList.some(
      (f) => f.trim().toLowerCase() === cleaned
    );

    if (!match) {
      showToast("We couldn't find that food in our database. Please try rephrasing or typing it manually.", "error");
      return;
    }

    onFetchSwap();
  };

  useEffect(() => {
    const cleaned = searchInput.toLowerCase().trim();

    const timeout = setTimeout(() => {
      if (cleaned.length < 3) {
        setFilteredFoodList([]);
        setShouldForceOpen(false);
        setTooltip("Type at least 3 characters");
      } else {
        const matches = foodList.filter((f) =>
          f.toLowerCase().includes(cleaned)
        );
        setFilteredFoodList(matches);
        setShouldForceOpen(matches.length > 1);
        setTooltip(""); // hide tooltip
      }
    }, 250); // debounce delay

    return () => clearTimeout(timeout);
  }, [searchInput, foodList]);


  return (
    <div>
      <label>Select a food:</label>
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <Select
          options={
            searchInput.length >= 3 || filteredFoodList.length > 0
              ? (filteredFoodList.length > 0 ? filteredFoodList : foodList).map((food) => ({
                label: food,
                value: food
              }))
              : []
          }

          ref={selectRef}
          value={
            selectedFood
              ? { label: selectedFood, value: selectedFood }
              : null
          }
          onChange={(selected) => {
            if (!selected) {
              // ❌ was clicked
              setSearchInput("");
              onFoodChange("");
              setFilteredFoodList([]);
              return;
            }

            const exactMatch = foodList.find(
              (f) => f.toLowerCase() === selected.value.toLowerCase()
            );
            const valueToUse = exactMatch || selected.value;
            
            setSearchInput(valueToUse);
            onFoodChange(valueToUse);
            setLastSelectedFood(valueToUse);
            setShouldForceOpen(false);
          }}

          onInputChange={(value) => {
            setSearchInput(value);
          }}

          openMenuOnFocus={true}
          onFocus={() => {
            setSearchInput(""); // ✅ clear the input for fresh typing
            setFilteredFoodList([]); // ✅ clear dropdown
            setTooltip("Type at least 3 characters");
            if (shouldForceOpen) {
              setShouldForceOpen(false); // reset to avoid sticky menu
            }
          }}
          onBlur={() => {
            const cleaned = searchInput.trim();
            if (cleaned === "") {
              setSearchInput(lastSelectedFood);        // ✅ restore prior selection
              // onFoodChange(lastSelectedFood);
              setFilteredFoodList([]);
              setTooltip("");
            }
          }}
          isSearchable
          isDisabled={loading || isListening}
          isClearable={true} 
          placeholder={isListening ? "🎙️ Listening..." : placeholderText}
          maxMenuHeight={200}
          noOptionsMessage={() =>
            searchInput.length < 3
              ? isListening
                ? "Listening..."
                : "Type at least 3 characters..."
              : "No matching foods found."
          }
          styles={{
            container: (base) => ({
              ...base,
              margin: "1rem 0",
              width: "80%",
              fontSize: "0.9rem",
              fontFamily: "inherit",
              opacity: isListening ? 0.6 : 1,
              transition: "opacity 0.3s ease"
            })
          }}
          filterOption={(option, inputValue) =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())
          }
        />

        {/* {tooltip && (
          <div style={{ fontSize: "0.8rem", color: "#888", marginTop: "-0.5rem", marginBottom: "0.5rem" }}>
            {tooltip}
          </div>
        )} */}

        {/* <VoiceInputButton
          foodList={foodList}
          onStart={() => {
            setSearchInput("");
            onFoodChange("");
            setFilteredFoodList([]); // clear dropdown
          }}
          onResult={(spokenText) => {
            const cleaned = spokenText.toLowerCase().trim();
            const matches = foodList.filter((f) =>
              f.toLowerCase().includes(cleaned)
            );

            if (matches.length === 0) {
              setPlaceholderText("No match found");
              setTimeout(() => setPlaceholderText("Search foods..."), 3000);
            }

            if (matches.length > 1) {
              setShouldForceOpen(true);
              selectRef.current?.focus(); // triggers dropdown
            } else {
              setShouldForceOpen(false);
            }

            setSearchInput(spokenText);
            onFoodChange(spokenText);
            setFilteredFoodList(
              foodList.filter((f) =>
                f.toLowerCase().includes(cleaned)
              )
            );
            // if (matches.length > 1 && selectRef.current) {
            //   selectRef.current.focus(); // ✅ open dropdown
            // }
            // if (matches.length <= 1 && selectRef.current) {
            //   selectRef.current.blur(); // ✅ close dropdown
            // }

            if (matches.length > 1) {
              setShouldForceOpen(true); // ✅ open the menu
            } else {
              setShouldForceOpen(false); // close if 0 or 1 match
            }

          }}
          onListeningChange={(state) => setIsListening(state)}
        /> */}

      </div>

      <button onClick={handleFetchSwap} disabled={loading || limitReached}>
        {loading ? (
          <>
            ⏳ Finding swap...
            <span className="spinner" style={{ marginLeft: "0.5rem" }} />
          </>
        ) : (
          "Get Healthy Swap"
        )}
      </button>
    </div>
  );
};

export default SwapForm;
